import { makeStyles } from '@mui/styles';

const useStaticContentFiltersModalStyle = makeStyles({
  modalPaper: {
    minWidth: 600,
    minHeight: 300,
  },
});

export default useStaticContentFiltersModalStyle;
